module.exports = __webpack_public_path__ + "img/IconTNW.4e9c4f9c.svg";